var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2109 0.960469L6.58591 6.58547C6.53367 6.63777 6.47163 6.67926 6.40335 6.70757C6.33506 6.73587 6.26186 6.75044 6.18794 6.75044C6.11402 6.75044 6.04083 6.73587 5.97254 6.70757C5.90425 6.67926 5.84222 6.63777 5.78997 6.58547L0.164974 0.960469C0.0862179 0.881801 0.0325736 0.781533 0.0108328 0.67236C-0.0109081 0.563188 0.000232026 0.450018 0.0428428 0.34718C0.0854536 0.244342 0.157619 0.15646 0.250203 0.0946575C0.342787 0.0328552 0.451627 -8.7428e-05 0.562943 1.74263e-07H11.8129C11.9243 -8.7428e-05 12.0331 0.0328552 12.1257 0.0946575C12.2183 0.15646 12.2904 0.244342 12.333 0.34718C12.3757 0.450018 12.3868 0.563188 12.3651 0.67236C12.3433 0.781533 12.2897 0.881801 12.2109 0.960469Z",
    fill: "#0B5226"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.6bd0d1b45c9a9e3b8e636951ef6cd697.svg";
export { ForwardRef as ReactComponent };